import "./RadioSelect.scss"
import classNames from "classnames";
import "../picking-input.scss"

const RadioSelect = ({value, label, name, checked, onChange, required, description}) => {
    return(
        <div className={classNames("radio-select", "picking-input")}>
            <input type="radio"
                   id={value}
                   name={name}
                   value={value}
                   checked={checked}
                   onChange={onChange} />
            <div>
                <label htmlFor={value} className={classNames({"required": required})}>{label}</label>
                {description && <p className="description">{description}</p>}
            </div>
        </div>
    )
}

export default RadioSelect;